import React, { useEffect, useState } from 'react';
import axios from 'axiosInstance';
import { Alert, Container, Spinner , Button} from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import '../css/AuthLogin.css'; 

const VerificarCuenta = () => {
  const { token } = useParams(); 
  const decodedToken = decodeURIComponent(token);
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');
    const navigate = useNavigate();

    const GoLogin = () => {
    navigate('/login');
  };

  useEffect(() => {
    const verificar = async () => {
      try {
       const res = await axios.get(process.env.REACT_APP_BACKEND_URL + `/api/auth/verify/${decodedToken}`);

        if (res.status === 204) {
          setStatus('success');
          setMessage('✅ ¡Tu cuenta ha sido verificada correctamente ya puedes iniciar sesion!');
        }
      } catch (err) {
        if (err.response?.status === 400 && err.response.data?.error?.includes('verificado')) {
          setStatus('already');
          setMessage('⚠️ Tu cuenta ya estaba verificada.');
        } else if (err.response?.status === 401) {
          setStatus('invalid');
          setMessage('❌ El token es inválido o ha expirado.');
        } else {
          setStatus('invalid');
          setMessage('❌ Ha ocurrido un error inesperado.');
        }
      }
    };

    if (token) {
      verificar();
    } else {
      setStatus('invalid');
      setMessage('❌ Token no encontrado en la URL.');
    }
  }, [token]);

  return (
    <Container className="mt-5 text-center" style={{ maxWidth: '600px' }}>
      <h2 className='Titulo'>Verificación de Cuenta</h2>
        <p>Por favor, espera mientras verificamos tu cuenta...</p>
        <Button className='boton_accion_user w-100' onClick={GoLogin}>
        Ir a Iniciar Sesión
      </Button>
      {status === 'loading' ? (
        <Spinner animation="border" role="status" className="mt-4">
          <span className="visually-hidden">Verificando...</span>
        </Spinner>
      ) : (
        <Alert variant={status === 'success' ? 'success' : (status === 'already' ? 'warning' : 'danger')} className="mt-4">
          {message}
        </Alert>
      )}
    </Container>
  );
};

export default VerificarCuenta;
